<template>
  <section class="xpress-reg-confirmation">
    <div class="confirmation-modal">
      <div class="notification-content">
        <h5>Session Timeout</h5>
        <button @click="buttonClicked">0K</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Timeout PopUp',
  setup () {
    return {
      buttonClicked: () => location.assign('/')
    }
  }
}
</script>

<style lang="scss" scoped>
  section.xpress-reg-confirmation {
    width: 100vw;
    height: 100vh;
    min-height: 30vh;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: scroll;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #E5E5E5;
    z-index: 15;

    &>div.confirmation-modal {
      width: 500px;
      height: 266px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.13);
      background: #FFFFFF;
      animation-name: confirmation-popup;
      animation-delay: 0;
      animation-duration: 2s;
      animation-iteration-count: 1;

      &>div.notification-content {
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        row-gap: 32px;

        &>p {
          width: 384px;
          height: 57px;
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 19px;
          text-align: center;
          color: #000000;
        }

        &>button {
          width: 76px;
          height: 39px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          border: transparent;
          border-radius: 5px;
          transition: filter 0.4s;
          background: $xpress-light-green;
          color: #FFFFFF;

          // hover
          &:hover {
            box-shadow: 0 0 5px #575f6e98;
            filter: brightness(0.8);
          }
          // active
          &:active {
            filter: brightness(1);
          }
        }
      }
    }
    // confirmation pop up
    @keyframes confirmation-popup {
      0% {
        opacity: 0;
        transition: all 0.2s;
      }
      100% {
        opacity: 1;
        transition: all 0.2s;
      }
    }
  }

  // MEDIA QUERY

  // XX-SM (<251px)
  @media (max-width: 250.9px) {
    section.xpress-reg-confirmation {
      &>div.confirmation-modal {
        width: 95%;
        height: auto;
        padding: 20px 2%;

        &>div.notification-content {
          row-gap: 22px;

          &>p {
            width: 97%;
            height: auto;
            font-size: 15px;
            line-height: 15px;
          }

          &>button {
            width: 70px;
            height: 35px;
          }
        }
      }
    }
  }
  // XX-SM
  @media (min-width: 251px) and (max-width: 350.9px) {
    section.xpress-reg-confirmation {
      padding-left: 5%;
      padding-right: 5%;

      &>div.confirmation-modal {
        width: 100%;
        height: 180px;
        padding: 20px 6%;

        &>div.notification-content {
          row-gap: 22px;

          &>p {
            width: 97%;
            height: auto;
            font-size: 15px;
            line-height: 15px;
          }

          &>button {
            width: 70px;
            height: 35px;
          }
        }
      }
    }
  }
  // X-SM
  @media (min-width: 351px) and (max-width: 575.9px) {
    section.xpress-reg-confirmation {
      padding-left: 10%;
      padding-right: 10%;

      &>div.confirmation-modal {
        width: 100%;
        height: 180px;
        padding: 20px 6%;

        &>div.notification-content {
          row-gap: 22px;

          &>p {
            width: 97%;
            height: auto;
            font-size: 16px;
            line-height: 15px;
          }

          &>button {
            width: 76px;
            height: 40px;
          }
        }
      }
    }
  }
  // SM
  @media (min-width: 576px) and (max-width: 767.9px) {

  }
  // MD
  @media (min-width: 768px) and (max-width: 991.9px) {

  }
  // LG
  @media (min-width: 992px) and (max-width: 1200.9px) {

  }
  // XL
  // @media (max-width: 1201px) {}
</style>
